// app/javascript/components/AdminDashboard.jsx
import React from "react";
import AdminNav from "./AdminNav";

export default function AdminDashboard() {
  return (
    <div>
      <AdminNav />
      <main className="container my-4">
        <h1 className="mb-4">Admin Dashboard</h1>

        <div className="card">
          <div className="card-body">
            <h2 className="h4 card-title">Games</h2>

            <p className="card-text">
              Add, edit, and publish games for the CS-STEM Network Games
              catalog.
            </p>

            <a href="/admin/games" className="btn btn-primary">
              Manage Games
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
